<template>
  <div class="page-col">
    <div class="page-main">
      <div class="list-header-premium d-flex flex-column flex-md-row align-items-center justify-content-between gap-3 p-0 mb-2" :class="{'bg-dark border-secondary': isDark}">
        <div class="d-flex align-items-center py-1 px-3 flex-shrink-0">
          <div class="header-icon-wrapper mr-3 ml-2" style="background: linear-gradient(135deg, #be123c 0%, #9f1239 100%);">
            <i class="fa fa-trash-o text-white"></i>
          </div>
          <div>
            <h4 class="mb-0 font-weight-bold" :class="isDark ? 'text-white' : 'text-dark'" style="font-size: 1.15rem;">Contas a Receber Excluídas</h4>
            <small class="text-muted small">Auditoria de títulos excluídos do sistema</small>
          </div>
        </div>

        <div class="d-flex align-items-center flex-wrap gap-2 py-1 px-3 w-100 w-md-auto justify-content-end list-header-actions">
          <div class="search-pill-responsive d-flex align-items-center bg-light rounded-pill p-1 shadow-xs border mr-2">
            <b-button-group class="mr-2 d-none d-lg-inline-flex">
              <b-button variant="link" class="btn-icon-only text-muted" @click="filtroAvancado = !filtroAvancado" v-b-tooltip.hover title="Filtros Avançados">
                <i class="fa fa-filter" :class="{'text-primary': filtroAvancado}"></i>
              </b-button>
              <b-button variant="link" class="btn-icon-only text-muted" @click="exportarExcel" v-b-tooltip.hover title="Exportar Excel">
                <i class="fa fa-file-excel-o"></i>
              </b-button>
              <b-button variant="link" class="btn-icon-only text-muted" @click="exportarHtml" v-b-tooltip.hover title="Imprimir Listagem">
                <i class="fa fa-print"></i>
              </b-button>
              <b-button variant="link" class="btn-icon-only text-danger" @click="limparFiltro" v-b-tooltip.hover title="Limpar Filtros">
                <i class="fa fa-ban"></i>
              </b-button>
            </b-button-group>

            <div class="d-flex align-items-center px-2 border-left mr-2 search-pill-field search-pill-field-data">
              <CecInputData v-model="filtroDataInicial" class="mx-1 search-pill-date" @keydown.enter.native="pesquisar" />
              <span class="text-muted mx-1 d-none d-sm-inline">até</span>
              <CecInputData v-model="filtroDataFinal" class="mx-1 search-pill-date" @keydown.enter.native="pesquisar" />
            </div>

            <div class="d-flex align-items-center px-2 border-left mr-2 search-pill-field search-pill-field-select">
              <b-form-select v-model="filtroTipoData" :options="tipoDataOptions" class="border-0 bg-transparent py-0 search-pill-select" />
            </div>

            <b-button variant="primary" pill class="px-4 font-weight-bold shadow-sm text-white btn-filtrar-responsive" :disabled="isBusy" @click="pesquisar">
              <i class="fa fa-search mr-1"></i>
              <span class="d-none d-sm-inline">FILTRAR</span>
            </b-button>
          </div>
        </div>
      </div>

      <b-collapse v-model="filtroAvancado">
        <div class="px-4 pb-4">
          <div class="card card-filter-premium compact-filter p-3 border-0 shadow-sm">
            <b-row align-v="end">
              <b-col md="6">
                <label class="small font-weight-bold text-muted">Pesquisa Rápida (Documento, Cliente, Descrição)</label>
                <b-form-input v-model="filtroGlobal" placeholder="Digite para filtrar na tabela..." class="shadow-xs rounded-pill" />
              </b-col>
            </b-row>
          </div>
        </div>
      </b-collapse>

      <b-row class="ml-0 mr-0 p-0" :class="isDark ? 'bg-dark' : 'bg-white'">
        <b-col sm="12" class="px-2">
          <div class="bg-white rounded border shadow-sm overflow-hidden">
            <b-table
              ref="tbl"
              class="mb-0 table-finance"
              :head-variant="isDark ? 'dark' : 'light'"
              :dark="isDark"
              show-empty
              empty-text="Nenhum registro encontrado"
              responsive
              sticky-header="600px"
              hover
              small
              :busy.sync="isBusy"
              :items="itensFiltrados"
              :fields="colunas"
              :filter="filtroGlobal">

              <template #cell(DT_CANC)="row">
                {{ formatarDataBR(row.item.DT_CANC) }}
              </template>

              <template #cell(DT_RECEB)="row">
                {{ formatarDataBR(row.item.DT_RECEB) }}
              </template>

              <template #cell(VL_ARECEBER)="row">
                <span class="text-right d-block font-weight-bold text-danger">{{ formatarMoeda(row.item.VL_ARECEBER) }}</span>
              </template>

              <template #cell(VL_DOC)="row">
                <span class="text-right d-block">{{ formatarMoeda(row.item.VL_DOC) }}</span>
              </template>

            </b-table>
          </div>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
import Tools from '@/tools/tools.js'
import CecInputData from '@/components/Cec/CecInputData.vue'
import { createCecTableToolsMixin } from '@/mixins/cecTableTools'
import { mapGetters } from 'vuex'
import { printHtmlReport, exportExcelXlsx } from '@/utils/RelatorioHTML'

export default {
  name: 'AreceberExcluidasListagem',
  components: {
    CecInputData
  },
  mixins: [createCecTableToolsMixin({
    rowsProp: 'lista',
    tblRef: 'tbl',
    filters: [
      { key: 'SEQUENCIA', type: 'number', label: 'ID' },
      { key: 'DOCUMENTO', type: 'string', label: 'Documento' },
      { key: 'CLIENTE_NOME', type: 'string', label: 'Cliente' },
      { key: 'DESCRICAO', type: 'string', label: 'Descrição' },
      { key: 'USUARIO', type: 'string', label: 'Usuário' }
    ]
  }, { useExternalPaging: false })],

  data() {
    return {
      isBusy: false,
      filtroAvancado: false,
      filtroGlobal: '',
      tipoDataOptions: [
        { value: 'DT_CANC', text: 'Data Exclusão' },
        { value: 'DT_DOC', text: 'Data Documento' },
        { value: 'DT_LANCAMENTO', text: 'Data Lançamento' },
        { value: 'DT_RECEB', text: 'Data Vencimento' }
      ],
      colunas: [
        { key: 'SEQUENCIA', label: 'ID', sortable: true, class: 'text-center' },
        { key: 'DOCUMENTO', label: 'Documento', sortable: true },
        { key: 'CLIENTE_NOME', label: 'Cliente', sortable: true },
        { key: 'DESCRICAO', label: 'Descrição', sortable: true },
        { key: 'DT_RECEB', label: 'Vencimento', sortable: true, class: 'text-center' },
        { key: 'VL_ARECEBER', label: 'Valor Aberto', sortable: true, class: 'text-right' },
        { key: 'VL_DOC', label: 'Valor Doc', sortable: true, class: 'text-right' },
        { key: 'DT_CANC', label: 'Excluído em', sortable: true, class: 'text-center' },
        { key: 'USUARIO', label: 'Usuário', sortable: true },
        { key: 'DSC_EXCLUSAO', label: 'Motivo/Obs', sortable: true }
      ]
    }
  },

  computed: {
    isDark() { return this.$store.getters['tema/IS_DARK'] },
    ...mapGetters('auditoria', [
      'RECEB_EXCLUIDAS',
      'RECEB_FILTRO_DATA_INICIAL',
      'RECEB_FILTRO_DATA_FINAL',
      'RECEB_FILTRO_TIPO_DATA'
    ]),
    lista() { return this.RECEB_EXCLUIDAS || [] },
    filtroDataInicial: {
      get() { return this.RECEB_FILTRO_DATA_INICIAL },
      set(value) { this.$store.commit('auditoria/SET_RECEB_FILTRO_DATA_INICIAL', value) }
    },
    filtroDataFinal: {
      get() { return this.RECEB_FILTRO_DATA_FINAL },
      set(value) { this.$store.commit('auditoria/SET_RECEB_FILTRO_DATA_FINAL', value) }
    },
    filtroTipoData: {
      get() { return this.RECEB_FILTRO_TIPO_DATA },
      set(value) { this.$store.commit('auditoria/SET_RECEB_FILTRO_TIPO_DATA', value) }
    }
  },

  methods: {
    async pesquisar() {
      this.isBusy = true
      try {
        await this.$store.dispatch('auditoria/GET_RECEB_EXCLUIDAS')
      } catch (err) {
        Tools.exibirMensagem(this.$store, 'Erro', 'danger', err)
      } finally {
        this.isBusy = false
      }
    },
    inicializarDatasFiltro() {
      const hoje = Tools.getDataAtual()
      if (!this.filtroDataInicial) this.filtroDataInicial = hoje
      if (!this.filtroDataFinal) this.filtroDataFinal = hoje
    },
    limparFiltro() {
      this.$store.commit('auditoria/SET_LIMPAR_RECEB')
      this.filtroGlobal = ''
      this.inicializarDatasFiltro()
      this.pesquisar()
    },
    formatarDataBR(data) {
      return Tools.formatarDataBR(data)
    },
    formatarMoeda(valor) {
      return new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(Number(valor || 0))
    },
    exportarExcel() {
      exportExcelXlsx({
        rows: this.itensFiltrados,
        columns: this.colunas,
        filename: 'AreceberExcluidas.xlsx',
        sheetName: 'Contas a Receber Excluidas'
      })
    },
    exportarHtml() {
      printHtmlReport({
        rows: this.itensFiltrados,
        columns: this.colunas,
        reportTitle: 'Contas a Receber Excluídas',
        printedBy: window.localStorage.getItem('login') || 'sistema',
        landscape: true
      })
    }
  },

  async created() {
    this.inicializarDatasFiltro()
    await this.pesquisar()
  }
}
</script>

<style scoped>
.table-finance {
  font-size: 0.82rem;
}
.header-icon-wrapper {
  width: 45px;
  height: 45px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 12px;
  font-size: 1.5rem;
}
.search-pill-responsive {
  min-height: 52px;
}
.search-pill-field {
  min-height: 38px;
}
.search-pill-date {
  width: 138px;
}
.search-pill-select {
  width: 170px;
}
.btn-icon-only {
  width: 38px;
  height: 38px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}
.shadow-xs {
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05) !important;
}
</style>



// WEBPACK FOOTER //
// src/views/auditoria/AreceberExcluidasListagem.vue